import { createContext, useContext } from "react";

export interface TableStylesContextValue {
  readonly styles: { readonly [key: string]: string };
  readonly columnTypeStyles: { readonly [key: string]: string };
}

export const TableStylesContext = createContext<TableStylesContextValue | null>(null);
TableStylesContext.displayName = "TableStylesContext";

export function useTableStyles(): TableStylesContextValue {
  const ctx = useContext(TableStylesContext);
  if (!ctx) throw new Error("useTableStyles must be used within a TableStylesContext.Provider");
  return ctx;
}
